import { render, staticRenderFns } from "./CPMCInformationTable.vue?vue&type=template&id=2f0a9457&scoped=true&"
import script from "./CPMCInformationTable.vue?vue&type=script&lang=js&"
export * from "./CPMCInformationTable.vue?vue&type=script&lang=js&"
import style0 from "./CPMCInformationTable.vue?vue&type=style&index=0&id=2f0a9457&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a9457",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VIcon,VRow,VSnackbar,VTextField,VToolbar})
